import * as QuoteActions from './../actions/quote.actions';
import { QuoteData } from '../models/quote.model';
import { AppState } from '../state/App.state';

const initialState: QuoteData = {
    inputRequest: {
        InputXML: {

        }
    },
    quotationId: '',
    referralReasons: [],
    status: ''
};

export function quoteDataReducer(state: QuoteData = initialState, action: QuoteActions.Actions): QuoteData {

    switch (action.type) {
        case QuoteActions.UPDATE_QUOTE_DATA:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

export const selectQuoteData = (state: AppState) => state.quoteData;
